import { render, staticRenderFns } from "./pc_header.vue?vue&type=template&id=5647afd9&scoped=true&"
import script from "./pc_header.vue?vue&type=script&lang=js&"
export * from "./pc_header.vue?vue&type=script&lang=js&"
import style0 from "./pc_header.vue?vue&type=style&index=0&id=5647afd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647afd9",
  null
  
)

export default component.exports